module.exports = __webpack_public_path__ + "static/media/SePeru-4.41fdc036.JPG";